var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"service-item-container normal-button",class:{
    active: _vm.isSelected,
    left: _vm.index % 3 == 0,
    center: _vm.index % 3 == 1,
    right: _vm.index % 3 == 2,
  },on:{"click":_vm.onClick}},[_c('span',{staticClass:"title",class:{ 'title-active': _vm.isSelected }},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }